import React from 'react';
import classNames from 'classnames';
import styles from 'src/components/icons/Icons.module.scss';
import PropTypes from 'prop-types';

const rotationMap = {
    up: 'rotation-90',
    right: null,
    down: 'rotation90',
    left: 'rotation180'
};

const IconChevron = ({ rotation = 'down', className, ...props }) => (
    <svg width="9" height="16" viewBox="0 0 9 16" fill="none"
        className={classNames(styles.svg, className, styles[rotationMap[rotation]])} {...props}
    >
        <path fillRule="evenodd" clipRule="evenodd"
            d="M0.810076 15.2101L8.05262 8.00003L0.813119 0.792991C0.637037 0.596897 0.331002 0.608904 0.149944 0.789962C-0.0366349 0.97654 -0.0365073 1.26364 0.150071 1.45022L6.71562 8.00003L0.149944 14.55C-0.0366349 14.7365 -0.0366349 15.0235 0.149944 15.2101C0.241177 15.3013 0.358976 15.35 0.48001 15.35C0.600938 15.35 0.718876 15.3012 0.810076 15.2101ZM0.21401 0.946778C0.130013 1.07103 0.144015 1.23202 0.256014 1.34402L6.92801 8.00002L6.92801 8.00003L0.25601 1.34403C0.14401 1.23203 0.13001 1.07103 0.21401 0.946778Z"
            fill="#979797"/>
    </svg>

);

IconChevron.propTypes = {
    rotation: PropTypes.oneOf(['up', 'down', 'right', 'left'])
};

export default IconChevron;
